import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-6 sm:py-12 px-4 bg-brand-cream scroll-mt-10" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start" data-id="element-146">
          {/* OPZIONE 1: COMPLETO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-brand-olive rounded-2xl p-5 sm:p-6 shadow-lg relative" data-id="element-147">
            <h3 className="text-base sm:text-lg font-bold text-brand-text-main mb-2 uppercase" data-id="element-148">
              OPZIONE 1: PACCHETTO COMPLETO
            </h3>
            <p className="text-xs sm:text-sm text-brand-text-muted mb-5" data-id="element-149">
              Tutto il sistema per cambiare da oggi.
            </p>

            <div className="space-y-2.5 sm:space-y-3 mb-6" data-id="element-150">
              {['I 6 Manuali del Metodo Mediterraneo', 'Tutti i 4 Bonus Esclusivi (Piano 30gg, Spesa, Snacks, Anti-gonfiore)', 'Accesso immediato e permanente (PDF HD)'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-151">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-olive shrink-0 mt-0.5" data-id="element-152" />
                  <span className="text-xs sm:text-sm text-brand-text-main font-medium" data-id="element-153">
                    {item}
                  </span>
                </div>)}
              <div className="flex items-start gap-2" data-id="element-154">
                <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 shrink-0 mt-0.5" data-id="element-155" />
                <span className="text-xs sm:text-sm text-brand-text-muted font-medium" data-id="element-156">
                  Metodo Reset 21 Giorni (Video-Corso Premium)
                </span>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-gray-100 pt-4 mb-5" data-id="element-157">
              <div data-id="element-158">
                <span className="text-[10px] sm:text-xs text-brand-text-muted uppercase font-bold block" data-id="element-159">
                  Valore Reale
                </span>
                <span className="text-base sm:text-lg text-gray-400 line-through" data-id="element-160">
                  €195
                </span>
              </div>
              <div className="text-right" data-id="element-161">
                <span className="text-[10px] sm:text-xs text-brand-olive uppercase font-bold block" data-id="element-162">
                  Oggi Solo
                </span>
                <span className="text-2xl sm:text-3xl font-bold text-brand-text-main" data-id="element-163">
                  €19,90
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44759694901383:1" variant="primary" className="w-full mb-3" data-id="element-164">
              🚀 VOGLIO IL PACCHETTO COMPLETO
            </CTAButton>
          </motion.div>

          {/* OPZIONE 2: PREMIUM */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-olive-dark text-white rounded-2xl p-5 sm:p-6 shadow-2xl relative border border-brand-gold/30 transform md:-translate-y-4" data-id="element-165">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-3 py-1 rounded-full text-[10px] sm:text-xs uppercase tracking-wide flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-166">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-167" />
              La scelta più popolare
            </div>

            <h3 className="text-base sm:text-lg font-bold text-brand-gold mb-2 mt-1 uppercase" data-id="element-168">
              OPZIONE 2: SISTEMA RESET PREMIUM ⭐
            </h3>
            <p className="text-xs sm:text-sm text-gray-200 mb-5" data-id="element-169">
              La scelta più popolare per una trasformazione definitiva.
            </p>

            <div className="space-y-3 sm:space-y-4 mb-6" data-id="element-170">
              <div className="flex items-start gap-2" data-id="element-171">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-172" />
                <span className="text-xs sm:text-sm font-medium" data-id="element-173">
                  TUTTO il Pacchetto Completo (6 Manuali + 4 Bonus)
                </span>
              </div>
              <div className="flex items-start gap-2 bg-white/10 p-3 rounded-xl border border-white/10" data-id="element-174">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-175" />
                <div data-id="element-176">
                  <span className="text-xs sm:text-sm font-bold text-brand-gold block mb-1" data-id="element-177">
                    ESCLUSIVO: IL METODO RESET 21 GIORNI
                  </span>
                  <span className="text-[10px] sm:text-xs text-gray-200" data-id="element-178">
                    Il programma avanzato passo-passo per resettare il tuo
                    metabolismo, organizzare la tua cucina da zero e consolidare
                    nuove abitudini in sole 3 settimane. Per chi non vuole più
                    fallire.
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-white/20 pt-4 mb-2" data-id="element-179">
              <div data-id="element-180">
                <span className="text-[10px] sm:text-xs text-gray-300 uppercase font-bold block" data-id="element-181">
                  Valore Reale
                </span>
                <span className="text-base sm:text-lg text-gray-400 line-through" data-id="element-182">
                  €292
                </span>
              </div>
              <div className="text-right" data-id="element-183">
                <span className="text-[10px] sm:text-xs text-brand-gold uppercase font-bold block" data-id="element-184">
                  Oggi Solo
                </span>
                <span className="text-3xl sm:text-4xl font-bold text-white" data-id="element-185">
                  €27,90
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full mb-3" data-id="element-186">
              🚀 VOGLIO IL SISTEMA PREMIUM
            </CTAButton>
          </motion.div>
        </div>
      </div>
    </section>;
}